import {bp} from './namespace.js';

$.extend(true, bp, {
  common: (function () {
    'use strict';

    return {
      show_loading_notification: function () {
        $('#loading-notification').fadeIn(100);
      },
      hide_loading_notification: function () {
        $('#loading-notification').fadeOut(100);
      },
      initialize_tagclouds: function () {
        var min_weight = false;
        var max_weight = false;
        var min_size = 100;
        var max_size = 160;
        var weight_value;

        $('.tagcloud a').each(function () {
          min_weight = (parseInt($(this).attr('data-weight'), 10) < min_weight || !min_weight) ? parseInt($(this).attr('data-weight'), 10) : min_weight;
          max_weight = (parseInt($(this).attr('data-weight'), 10) > max_weight || !max_weight) ? parseInt($(this).attr('data-weight'), 10) : max_weight;
        });

        weight_value = (max_size - min_size) / (max_weight - min_weight);
        $('.tagcloud a').each(function () {
          $(this).css('font-size', (min_size + (parseInt($(this).attr('data-weight'), 10) - min_weight) * weight_value) + '%');
        });
      },
      goToLink: function (link) {
        document.location = link;
      },
    };
  })(),
});

export {bp};
